import { statusValues } from '@bsa/scouting-js-utils/src/constants/advancements';

import type { YouthRankAdvancement } from '@appTypes/esb';
import { parseStatus } from '@shared/utils/advancementDisplay';

/**
 * The level of the rank the youth is working on: one past the highest they have
 * approved or awarded, or the first rank when they have none yet.
 *
 * Ranks are earned in order, so that rank is shown as in progress even before
 * any requirement is signed off, which is what tells a leader where the youth is.
 */
export function currentRankLevel(ranks: YouthRankAdvancement[]): number {
  const earnedLevels = ranks
    .filter(
      rank => statusValues[parseStatus(rank.status)] >= statusValues.APPROVED,
    )
    .map(rank => Number(rank.level));

  return earnedLevels.length ? Math.max(...earnedLevels) + 1 : 1;
}
